export const CAR_VENDOR_MAP: Record<string, string> = {
  AB: 'Amy Training',
  AC: 'Ace',
  AD: 'Advantage',
  AG: 'All Car Leasing',
  AH: 'Athol',
  AI: 'Artic',
  AL: 'Alamo',
  AM: 'America Car Rent',
  AR: 'AZ Rent',
  AT: 'Atesa',
  AV: 'Avant',
  BB: 'Buchbinder',
  BG: 'Budget Group',
  BV: 'Bidvest Car',
  CC: 'Capitol Car Hire',
  CD: 'Car Rent',
  CE: 'Centauro',
  CI: 'CITER',
  CL: 'Cal Auto',
  CM: 'Car2move',
  CR: 'Clickrent',
  CW: 'Carvenience',
  CY: 'CyprusaptcaR',
  DA: 'Drivalia',
  DD: 'Addcar',
  DF: 'Driving Force',
  DL: 'Drive4Less',
  DM: 'Drive A Matic',
  DO: 'Drive On',
  DR: 'Drive And Go',
  DS: 'Discount',
  EA: 'Easycar',
  EB: 'Advantage Ez Gro',
  EC: 'East Coast',
  EE: 'Exe',
  EG: 'Enterprise Group',
  EM: 'Euromobil',
  EO: 'EcoRent',
  EP: 'Europcar',
  ES: 'Easirent',
  ET: 'Enterprise',
  EU: 'EuroRent',
  EX: 'Executive',
  EY: 'Economy Rent A C',
  EZ: 'EZ Rent A Car',
  FF: 'Firefly',
  FI: 'FiRent',
  FO: 'Foco',
  FR: 'First Car Rental',
  FT: 'Fleet',
  FX: 'Fox',
  FY: 'Firefly',
  FZ: 'Flizzr',
  GB: 'Global',
  GC: 'Gold Car',
  GD: 'Get Your Car',
  GI: 'Green Motion',
  GM: 'Groundspan Limo',
  GO: 'Go Rent',
  GR: 'Garenta',
  GS: 'Drive Me',
  GU: 'Guerin',
  HG: 'Hertz Group',
  HK: 'Hawk',
  IA: 'Adria',
  IC: 'Island Car',
  IM: 'Europcar SAfrica',
  IN: 'Invensys',
  IR: 'Interent',
  IV: 'Ilha Verde',
  JM: 'Jumbo',
  JO: 'Jeannie',
  KD: 'Keddy',
  LL: 'Localiza',
  LM: 'L & M Car Rental',
  LN: 'Location',
  LT: 'Locauto',
  LZ: 'Loclaliza',
  MB: 'Mobacar',
  MD: 'Megadrive',
  MG: 'Maggiore',
  MM: 'MM Cars',
  MO: 'Movida',
  MR: 'MexRent',
  MW: 'Midway',
  MX: 'Mex Rental',
  MY: 'MyCar',
  NA: 'Albania Rentacar',
  NC: 'NextCar',
  NK: 'Nokta',
  NS: 'Nissan',
  NU: 'Nu Car Rentals',
  NZ: 'Niza',
  OK: 'OK Rent',
  OR: 'Oryx',
  PA: 'Prima',
  PC: 'Procar',
  PI: 'Prime',
  PR: 'Priceless',
  RE: 'Right Executive',
  RG: 'Right Cars',
  RH: 'Rhodium',
  RN: 'Posrednik',
  RO: 'Routes Car Renta',
  RR: 'SR Rent',
  RW: 'Rent A Wreck',
  SC: 'Silvercar',
  SF: 'Switchforce',
  SN: '62N Faroe',
  SR: 'State Van Rental',
  ST: 'Stoutes',
  SU: 'Surprice',
  SV: 'U-Save',
  SX: 'Sixt',
  SY: 'Sicily By Car',
  TC: 'Travel Car',
  TE: 'Tempest',
  TH: 'Thai Rent A Car',
  TP: 'Turis Prime',
  TR: 'Top Rent',
  UG: 'U Save Group',
  UN: 'Unidas',
  VR: 'AVR',
  WF: 'Woodford Rentals',
  WR: 'WinRent',
  ZA: 'Payless',
  ZD: 'Budget',
  ZE: 'Hertz',
  ZI: 'Avis',
  ZL: 'National',
  ZR: 'Dollar',
  ZT: 'Thrifty',
};
